module.exports = __webpack_public_path__ + "static/javascript_fullstack_online_bootcamp-3ed18a48ab754374b1537e7cea491d62.jpg";